"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByRelevantMatch = sortByRelevantMatch;
exports.matchFieldValueToOption = matchFieldValueToOption;
exports.InputAutocompleteGroup = exports.FieldAutocomplete = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _FieldLayout = require("./layout/FieldLayout");

var _FieldLabel = require("./microFields/FieldLabel");

var _FieldValidationMessage = require("./microFields/FieldValidationMessage");

var _fieldUtils = require("./microFields/fieldUtils");

var _fieldAttrsUtils = require("./microFields/fieldAttrsUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * sortByRelevantMatch
 * Low LOE - enhance component later to allow passing a custom sort?
 * @param  {Object} option1
 * @param  {Object} option2
 * @param  {String} value   [field value]
 * @return {Number} index
 */
function sortByRelevantMatch(option1, option2, value) {
  var aLower = option1.label.toLowerCase();
  var bLower = option2.label.toLowerCase();
  var valueLower = value.toLowerCase();
  var queryPosA = aLower.indexOf(valueLower);
  var queryPosB = bLower.indexOf(valueLower);

  if (queryPosA !== queryPosB) {
    return queryPosA - queryPosB;
  }

  return aLower < bLower ? -1 : 1;
}
/* TODO: enhance component later? .. maybe some smaller lists want to show values on an empty field? */

/* could pass custom functions or make configurable defaults */

/**
 * matchFieldValueToOption
 * @param  {Object} option
 * @param  {String} value   [field value]
 * @return {Boolean}
 */


function matchFieldValueToOption(option, value) {
  /* don't show an overwhelmingly long list for an empty field */
  if (!value) {
    return false;
  }

  return option.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 || option.value.toLowerCase().indexOf(value.toLowerCase()) !== -1;
}
/* the lib is adding page positioning inline - so play along */

/* overrides defaults being added by lib for position, width, minWidth */

/* sticky -- seems to work in IE (mindblown) */


var inlineMenuStyles = {
  borderRadius: '2px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
  fontSize: '1rem',
  position: 'sticky',
  overflow: 'auto',
  width: '100%',
  minWidth: 'initial',
  maxHeight: '200px'
};
/**
 * Get the choice component.  This is used by the Autocomplete when it lists options.
 * @param {Object} choice - the choice to display, in the shape of:
 *      {string} value - the value of the choice
 *      {string} label - the display label for the choice
 * @param {boolean} isHighlighted - whether the choice is currently being displayed as highlighted
 * @return {node} the JSX of the component
 */

var getChoiceComponent = function getChoiceComponent(choice, isHighlighted) {
  return _react.default.createElement("div", {
    className: (0, _dedupe.default)('field-auto-option', {
      'field-auto-option__highlighted': isHighlighted
    }),
    key: choice.value
  }, choice.label);
};
/* input unstyled - but the list options and container do have default styles */


var FieldAutocomplete = function FieldAutocomplete(_ref) {
  var value = _ref.value,
      inputProps = _ref.inputProps,
      wrapperProps = _ref.wrapperProps,
      choices = _ref.choices,
      renderItem = _ref.renderItem,
      getItemValue = _ref.getItemValue,
      shouldItemRender = _ref.shouldItemRender,
      sortItems = _ref.sortItems,
      _onChange = _ref.onChange,
      onSelect = _ref.onSelect;
  return _react.default.createElement(_reactAutocomplete.default, {
    value: value,
    inputProps: _objectSpread({}, inputProps, {
      style: {}
    }),
    menuStyle: inlineMenuStyles,
    wrapperProps: wrapperProps,
    wrapperStyle: {},
    items: choices,
    getItemValue: getItemValue,
    shouldItemRender: shouldItemRender,
    sortItems: sortItems,
    onChange: function onChange(event, newValue) {
      return _onChange(newValue);
    },
    onSelect: onSelect,
    renderItem: renderItem
  });
};

exports.FieldAutocomplete = FieldAutocomplete;
FieldAutocomplete.defaultProps = {
  value: '',
  // optionally - add html attrs to containing div
  wrapperProps: {},
  // add html attrs to the input within Autocomplete
  // some values are passed by the lib.. more info in the docs (https://github.com/reactjs/react-autocomplete)
  inputProps: {},
  renderItem: getChoiceComponent,
  getItemValue: function getItemValue(option) {
    return option.value;
  },
  shouldItemRender: matchFieldValueToOption,
  sortItems: sortByRelevantMatch,
  onChange: function onChange() {},
  onSelect: function onSelect() {}
};
FieldAutocomplete.propTypes = {
  choices: _propTypes.default.array.isRequired,
  value: _propTypes.default.string,
  inputProps: _propTypes.default.object,
  wrapperProps: _propTypes.default.object,
  renderItem: _propTypes.default.func,
  getItemValue: _propTypes.default.func,
  shouldItemRender: _propTypes.default.func,
  sortItems: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onSelect: _propTypes.default.func
};

var InputAutocompleteGroup = function InputAutocompleteGroup(_ref2) {
  var fieldName = _ref2.fieldName,
      value = _ref2.value,
      atts = _ref2.atts,
      label = _ref2.label,
      cashbotName = _ref2.cashbotName,
      isRequiredField = _ref2.isRequiredField,
      choices = _ref2.choices,
      wrapperProps = _ref2.wrapperProps,
      renderItem = _ref2.renderItem,
      getItemValue = _ref2.getItemValue,
      shouldItemRender = _ref2.shouldItemRender,
      sortItems = _ref2.sortItems,
      onChange = _ref2.onChange,
      onSelect = _ref2.onSelect,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      isInvalid = _ref2.isInvalid,
      isTouched = _ref2.isTouched,
      errorMessage = _ref2.errorMessage,
      warningMessage = _ref2.warningMessage,
      rest = _objectWithoutProperties(_ref2, ["fieldName", "value", "atts", "label", "cashbotName", "isRequiredField", "choices", "wrapperProps", "renderItem", "getItemValue", "shouldItemRender", "sortItems", "onChange", "onSelect", "onFocus", "onBlur", "isInvalid", "isTouched", "errorMessage", "warningMessage"]);

  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var validationProps = (0, _fieldUtils.getValidationProps)(value, isInvalid, isTouched, warningMessage, errorMessage);
  var showInvalid = validationProps.isInvalid;
  var inputProps = (0, _fieldAttrsUtils.inputAttributes)(_objectSpread({}, rest, {
    fieldName: fieldName,
    atts: atts,
    label: label,
    isRequiredField: isRequiredField,
    isInvalid: showInvalid
  }));
  var labelProps = {
    fieldName: fieldName,
    label: label,
    isInvalid: showInvalid
  };
  var validationMsgProps = {
    id: fieldIds.validation.id,
    fieldName: fieldName,
    validationProps: validationProps
  };
  var autoProps = {
    choices: choices,
    inputProps: _objectSpread({}, inputProps, {
      onBlur: onBlur,
      onFocus: onFocus
    }),
    wrapperProps: wrapperProps,
    renderItem: renderItem,
    getItemValue: getItemValue,
    shouldItemRender: shouldItemRender,
    sortItems: sortItems,
    onChange: onChange,
    onSelect: onSelect,
    value: value
  };
  return _react.default.createElement(_FieldLayout.FieldWrapper, {
    fieldName: fieldName,
    cashbotName: cashbotName
  }, _react.default.createElement(_FieldLabel.FieldLabel, labelProps), _react.default.createElement(_FieldLayout.FieldDivWrapper, null, _react.default.createElement(FieldAutocomplete, autoProps)), _react.default.createElement(_FieldValidationMessage.FieldValidationMessage, validationMsgProps));
};

exports.InputAutocompleteGroup = InputAutocompleteGroup;
InputAutocompleteGroup.defaultProps = {
  atts: {
    type: 'text'
  },
  isRequiredField: true,
  wrapperProps: {},
  renderItem: null,
  getItemValue: null,
  shouldItemRender: null,
  sortItems: null,
  onSelect: function onSelect() {},
  onFocus: function onFocus() {},
  isInvalid: false,
  isTouched: false,
  warningMessage: null,
  errorMessage: null
};
InputAutocompleteGroup.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  atts: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['email', 'tel', 'text'])
  }),
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  isRequiredField: _propTypes.default.bool,
  choices: _propTypes.default.array.isRequired,
  wrapperProps: _propTypes.default.object,
  renderItem: _propTypes.default.func,
  getItemValue: _propTypes.default.func,
  shouldItemRender: _propTypes.default.func,
  sortItems: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  onSelect: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func.isRequired,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  warningMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};